import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
} from "firebase/firestore/lite";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { db } from "../../firebase.config";

function Failed() {
  const location = useLocation();
  useEffect(() => {
    const { payload, userCart } = location.state;
    console.log(payload, userCart);
    const userDocId = payload.docId;
    //Function For Adding Order to Subcollection
    const addCartToOrders = async (userDocId, userCart) => {
      console.log("ref:", userDocId);
      const userDocRef = doc(db, "users", userDocId);

      // Reference the subcollection
      const subcollectionRef = collection(userDocRef, "orders");

      // Add NewOrder to the subcollection

      const newOrder = {
        date: new Date(),
        server: serverTimestamp(),
        total: payload.total,
        payment: false,
        items: userCart,
      };

      // Add a new document to the subcollection
      const docRef = await addDoc(subcollectionRef, newOrder);

      console.log("ref:", userDocId);
      console.log(`Document written with ID: ${docRef.id}`);
      console.log(`Document written with ID: ${docRef}`);
    };

    addCartToOrders(userDocId, userCart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-3 text-center items-center justify-center py-auto mb-5 h-screen">
      <img
        src="https://i0.wp.com/balututorials.com/wp-content/uploads/2020/07/Error.gif"
        className="w-28"
        alt="PaymentFailed"
      />
      <p className="flex text-lg font-bodyFont font-bold text-red-500">
        Payment Failed : (
      </p>
      <Link to={"/"}>
        <p className="flex text-md font-bodyFont font-bold text-slate-600">
          Return to home
        </p>
      </Link>
    </div>
  );
}

export default Failed;
